import { SkeletonLine } from '@cointracker/styleguide/src/Skeleton';
import { selectLoading } from './Loading.css';

export const SelectLoading = () => {
  return (
    <div className={selectLoading}>
      <SkeletonLine height={48} />
    </div>
  );
};
